import style from './style.module.scss'
import { useContext } from 'react'
import { Header, Text } from '@crossfit/design-system'
import { NavContext } from 'components/Admin/Shared/Menu/Shared/context'
import { ReactComponent as Minus } from 'components/Admin/Shared/Menu/Shared/Header/minus.svg'
import { ReactComponent as Plus } from 'components/Admin/Shared/Menu/Shared/Header/plus.svg'
import { useSelector } from 'react-redux'
import { getAffiliate } from 'store/selectors'

export const Mobile = () => {
  const { navOpen, setNavOpen } = useContext(NavContext)
  const affiliate = useSelector(getAffiliate)
  return (
    <div className={style.container}>
      <div className={style.affiliateContainer}>
        <div className={style.affiliateHeader}>
          <Text
            as='label'
            type='overline'
            size='sm'
            bold
            className={style.subHeader}
          >
            {'Manage My Affiliate'.toUpperCase()}
          </Text>
          <Header as='h1' size='sm' className={style.header}>
            {affiliate.name}
          </Header>
        </div>
        <div className={style.navControl} onClick={() => setNavOpen(!navOpen)}>
          {navOpen ? <Minus /> : <Plus />}
        </div>
      </div>
    </div>
  )
}
